import { Component } from '@angular/core';

import { DynamicLayoutSlotComponent } from '@frontend/vanilla/core';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [DynamicLayoutSlotComponent],
    selector: 'vn-am-slot',
    templateUrl: 'slot.html',
})
export class SlotComponent extends AccountMenuItemBase {
    constructor() {
        super();
    }
}
